module.exports = __webpack_public_path__ + "assets/icon-approved.8150e2e3.svg";